import { GeoSource, ProfileTestObjectSource, PulsarMetrics } from "../@types"
import { assertNumeric, assertString } from "./sessionConfigValidation"

export interface ProfileTestObject {
  geoRules: GeoSource | undefined
  pulsarMetrics: PulsarMetrics | undefined
  testObjectPath: string
  testObjectSize: number
  targetFrequency: number
  testObjectTimeout: number
}

export const createProfileTestObject: (
  source: ProfileTestObjectSource,
  continent: string,
  country: string,
) => ProfileTestObject = (s, continent, country) =>
  new ProfileTestObjectImpl(s, continent, country)

const getTargetFrequencyCountryOverride = (
  geoSource: GeoSource | undefined,
  country: string,
) => {
  /* eslint-disable @typescript-eslint/dot-notation */
  const settings =
    (geoSource &&
      geoSource["country"] &&
      geoSource["country"]["target_frequency"]) ||
    {}
  /* eslint-enable @typescript-eslint/dot-notation */
  return settings[country]
}

const getTargetFrequencyContinentOverride = (
  geoSource: GeoSource | undefined,
  continent: string,
) => {
  /* eslint-disable @typescript-eslint/dot-notation */
  const settings =
    (geoSource &&
      geoSource["continent"] &&
      geoSource["continent"]["target_frequency"]) ||
    {}
  /* eslint-enable @typescript-eslint/dot-notation */
  return settings[continent]
}

class ProfileTestObjectImpl implements ProfileTestObject {
  private _geoRules
  private _pulsarMetrics
  private _testObjectPath
  private _testObjectSize
  private _targetFrequency
  private _testObjectTimeout
  constructor(
    source: ProfileTestObjectSource,
    reporterContinent: string,
    reporterCountry: string,
  ) {
    /* eslint-disable @typescript-eslint/dot-notation */
    this._geoRules = source["geo"]
    const tempSize = source["size"]
    assertNumeric("profile test object size", tempSize)
    this._testObjectSize = tempSize
    const tempTargetFrequency = source["target_frequency"]
    assertNumeric("profile test object target_frequency", tempTargetFrequency)
    this._targetFrequency =
      // Country-level override takes precedence
      getTargetFrequencyCountryOverride(this._geoRules, reporterCountry) ||
      getTargetFrequencyContinentOverride(this._geoRules, reporterContinent) ||
      tempTargetFrequency
    this._pulsarMetrics = source["metrics"]
    const tempPath = source["path"]
    assertString("profile test object path", tempPath)
    this._testObjectPath = tempPath
    const tempTimeout = source["timeout"]
    assertNumeric("profile test object timeout", tempTimeout)
    this._testObjectTimeout = tempTimeout
    /* eslint-enable @typescript-eslint/dot-notation */
  }

  get geoRules() {
    return this._geoRules
  }

  get pulsarMetrics() {
    return this._pulsarMetrics
  }

  get targetFrequency() {
    return this._targetFrequency
  }

  get testObjectPath() {
    return this._testObjectPath
  }

  get testObjectSize() {
    return this._testObjectSize
  }

  get testObjectTimeout() {
    return this._testObjectTimeout
  }
}
